import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c24d01e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accordion accordion-unbordered accordion-multiselectable" }
const _hoisted_2 = { class: "mb-5 product-box" }
const _hoisted_3 = ["aria-controls", "aria-expanded", "id"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-11" }
const _hoisted_6 = ["id", "aria-hidden"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-6" }, null, -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  key: 0,
  class: "col-4 actions"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = { class: "action-div" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#list-alt" })
], -1))
const _hoisted_13 = ["id"]
const _hoisted_14 = {
  "aria-label": "Opsummering af blanket",
  class: "table table--borderless table--compact table--responsive-headers d-print-table"
}
const _hoisted_15 = { class: "w-percent-md-30" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.formular.products, (p, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: p,
        class: _normalizeClass({ 'print-break-before': this.printMode })
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            "aria-controls": 'product-'+index,
            "aria-expanded": this.printMode,
            class: "accordion-button product-accordion",
            id: 'product-button-'+index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", null, _toDisplayString(p.formular.trin[1].felter[0].vaerdi ? p.formular.trin[1].felter[0].vaerdi : 'Produkt #' + (index + 1)), 1)
              ])
            ])
          ], 8, _hoisted_3),
          _createElementVNode("div", {
            id: 'product-'+index,
            "aria-hidden": !this.printMode,
            class: "accordion-content product-accordion"
          }, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (!this.printMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("h5", null, [
                      _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-opsummering.handlinger.titel" })
                    ]),
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_router_link, {
                        to: '/blanketTG/resultat/' + _ctx.id,
                        class: "function-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-opsummering.se-score.titel" })
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass((this.printMode ? 'col-11 summary-margins' : 'col-7') + ' summary-details')
              }, [
                _createElementVNode("h2", {
                  class: "mt-405",
                  id: 'product-summary-label-'+index
                }, [
                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-opsummering.oplysninger.titel" })
                ], 8, _hoisted_13),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.formular.trin.slice(1, p.formular.trin.length), (trin) => {
                  return (_openBlock(), _createElementBlock("span", { key: trin }, [
                    _createElementVNode("h3", null, _toDisplayString(trin.overskrift), 1),
                    _createElementVNode("table", _hoisted_14, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trin.felter.filter(f => f.felttype !== _ctx.FeltType.OVERSKRIFT && f.felttype !== _ctx.FeltType.HIDDEN), (felt) => {
                          return (_openBlock(), _createElementBlock("tr", { key: felt }, [
                            _createElementVNode("th", _hoisted_15, _toDisplayString(felt.maerkat), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.lavVistNavn(felt)) + " " + _toDisplayString(felt.enhed), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                }), 128))
              ], 2)
            ])
          ], 8, _hoisted_6)
        ])
      ], 2))
    }), 128))
  ]))
}